export const iconFontAwesomeAnimalsFishFins = (
	<i className="fa-solid fa-fish-fins"></i>
);
